<div *ngIf="modifiedDocuments && modifiedDocuments.length > 0">
  <h4 id="documents-to-pay-header">
    {{ 'ARC_PAYMENT_DOCUMENTS' | translate }}
  </h4>
  <shared-document-table-component
    [modifiedDocuments]="modifiedDocuments"
    [isReadOnly]="isReadOnly"
    [paymentRules]="paymentRules"
    [statementPaymentAllowed]="statementPaymentAllowed"
    [disputeReasons]="disputeReasons"
    [paymentDate]="paymentDate"
    [discountMetadata]="discountMetadata"
    [previewPayables]="previewPayables"
    (editPayableAmount)="onEditPayableAmount($event)"
    (updateAppliedDiscountAmount)="onUpdateAppliedDiscountAmount()"
    (markDocumentAsModified)="onMarkDocumentAsModified($event)"
    (selectedDocumentsChanged)="onSelectedDocumentsChanged($event)"
  ></shared-document-table-component>
</div>
